// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608170404/js/" + chunkId + "." + {"44":"2ba2f36f","225":"c4731939","481":"e417e55f","486":"173602e5","770":"37d1a4e7"}[chunkId] + ".0.0899632195945157.chunk.js";
};